import { useCallback, useRef, useState } from "react";
import DefaultButton from "./DefaultButton";
import { Col, Row } from "./Grid";
import TextInput from "./TextInput";
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types'
import ReactForm from "./ReactForm";
import { fetch } from "../utils/fetch";

const ForgottenPassword = ({ url = '/api/v1/forgottenPassword' }) => {
    const { t } = useTranslation();
    const [success, setSuccess] = useState();
    const [submitted, setSubmitted] = useState(false);
    const [username, setUsername] = useState();
    const formRef = useRef();

    const doReset = useCallback(async () => {
        setSubmitted(true);
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username })
            });
            if (response.ok) {
                const data = await response.json();
                setSuccess(data.result);
            }
        } catch {
            setSuccess(false);
        } finally {
            setSubmitted(false);
            setUsername();
        }
    }, [url, username]);
    
    return <div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px', color: 'white' }}>
        { success === undefined && <ReactForm ref={formRef}>
                <Row>
                    <Col>{t('forgottenPasswordInstruction')}</Col>
                </Row>
                <Row>
                    <Col>
                        <TextInput value={username} live={true} placeholder={t('username')} onChange={setUsername} maxLength={256} required></TextInput>
                    </Col>
                </Row>
                <Row>
                    <Col className="px-1 py-2">
                        <DefaultButton className="w-100" kind="submit" variant="solid-success" disabled={!username || username.length === 0} processing={submitted} onClick={doReset}></DefaultButton>
                    </Col>
                </Row>
            </ReactForm> }
        { success === false && <p>{t('forgottenPasswordFailed')}</p> }
        { success === true && <p>{t('forgottenPasswordSuccess')}</p> }
    </div>
}
ForgottenPassword.propTypes = {
    url: PropTypes.string.isRequired
}
export default ForgottenPassword;